export enum ImageType {
  Logo = "logo",
  Sponsors = "sponsors"
}
